interface Props {
  children: React.ReactNode
}

export const ContentContainer = ({ children }: Props) => {
  return <div className="mb-20 h-fit w-full max-w-screen-3xl self-center px-12 pb-6">{children}</div>
}
